import { render, staticRenderFns } from "./ChangeInboundNotes.vue?vue&type=template&id=42b3218e&"
import script from "./ChangeInboundNotes.vue?vue&type=script&lang=js&"
export * from "./ChangeInboundNotes.vue?vue&type=script&lang=js&"
import style0 from "./ChangeInboundNotes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports